import { createBatchQueue } from "./batchQueue";

const enqueue = createBatchQueue({ missingValue: "none" }); // absent id = no status record

export function fetchStatusBatched(contentId, fetchBatchStatuses) {
  return enqueue(contentId, fetchBatchStatuses);
}
